import { observable, action } from 'mobx';

import { Alert, AlertMessage, AlertTypes } from '../models';
import { DefaultAlertOptions } from '../constants';
import { CoreUtil } from '../utils';

export default class AlertStore {
    @observable.ref alerts: Alert[] = [];

    @action alert = (alert: Alert) => {
        if (alert.type === AlertTypes.clear) {
            this.alerts = this.alerts.filter((alert) => {
                const persit = alert.options?.persist;
                if (!persit) {
                    clearTimeout(alert.timerId);
                }
                return persit;
            });
        } else {
            if (alert.options?.fadeTime) {
                alert.timerId = setTimeout(() => this.remove(alert), alert.options?.fadeTime);
            }
            this.alerts = [...this.alerts, alert];
        }
    };

    @action success(successMessage: AlertMessage, id = 'global', options = DefaultAlertOptions) {
        const { message, description } = successMessage;
        this.alert({
            id,
            options,
            message,
            description,
            type: AlertTypes.success
        });
    }

    @action warn(warnMessage: AlertMessage, id = 'global', options = DefaultAlertOptions) {
        const { message, description } = warnMessage;
        this.alert({
            id,
            options,
            message,
            description,
            type: AlertTypes.warning
        });
    }

    @action error(error: any, errorMessageHandler: any, id = 'global', options = DefaultAlertOptions) {
        const { message, description } = errorMessageHandler
            ? errorMessageHandler(error)
            : CoreUtil.defaultErrorMessage(error);
        this.alert({
            id,
            options,
            message,
            description,
            type: AlertTypes.error
        });
    }

    @action info(infoMessage: AlertMessage, id = 'global', options = DefaultAlertOptions) {
        const { message, description } = infoMessage;
        this.alert({
            id,
            options,
            message,
            description,
            type: AlertTypes.info
        });
    }

    @action clear(id = 'default-clear') {
        this.alert({ id, type: AlertTypes.clear });
    }

    @action remove(alert: Alert) {
        clearTimeout(alert.timerId);
        this.alerts = this.alerts.filter((_alert) => _alert !== alert);
    }
}

export const alertStore = new AlertStore();
